export const GAME = {
    // ゲームの設定
    TIME_PER_QUESTION: 20,          //問題ごとの制限時間(秒)
    PIN_FIXED_TIME: 5,              //ピン留めされる時間(秒)
    PIN_FIXED_LOWER_PRICE: 3000,    //ピン留めするスパチャの最低金額
    PLAYER_NAME: "フリスタオ",       //プレイヤー名
    NEXT_QUESTION_INTERVEL: 5000,   //次の問題までの待ち時間(ミリ秒)
}

export const SUPER_CHAT = {
    // スーパーチャットの値段
    PRICE_LEVEL_0: 0,
    PRICE_LEVEL_1: 300,
    PRICE_LEVEL_2: 500,
    PRICE_LEVEL_3: 1000,
    PRICE_LEVEL_4: 2000,
    PRICE_LEVEL_5: 3000,
    PRICE_LEVEL_6: 5000,
    PRICE_LEVEL_7: 10000,
    // スーパーチャットの秒数
    TIME_LEVEL_1: 2,
    TIME_LEVEL_2: 4,
    TIME_LEVEL_3: 6,
    TIME_LEVEL_4: 8,
    TIME_LEVEL_5: 11,
    TIME_LEVEL_6: 14,
    TIME_LEVEL_7: 17,
    // 特別キャスト
    CAST1_NAME: '仲野義嗣',
    CAST1_IMAGE_NAME: 'cast1.jpg',
    CAST2_NAME: '飯日友弥',
    CAST2_IMAGE_NAME: 'cast2.jpg',
}

